module.exports = __webpack_public_path__ + "img/discount_white.d8e5b46f.png";